import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const machineServiceDocumentStatus = enumerated({
  pending: 'Pendente',
  success: 'Sucesso',
  failed: 'Falhou',
})

export const machineServiceDocumentObject = z.object({
  id: z.string().uuid(),
  machineServiceId: z.string().uuid(),
  privateFileId: z.string().uuid().nullish(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  fileName: z.string().nullish(),
  mimeType: z.string().nullish(),
  status: machineServiceDocumentStatus,
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const machineServiceDocumentCreateInputObject = machineServiceDocumentObject
  .pick({
    id: true,
    machineServiceId: true,
    privateFileId: true,
    gcsIdentifier: true,
    url: true,
    fileName: true,
    mimeType: true,
    status: true,
  })
  .extend({
    id: machineServiceDocumentObject.shape.id.nullish(),
    status: machineServiceDocumentObject.shape.status.nullish(),
  })

export const machineServiceDocumentUpdateInputObject = machineServiceDocumentObject
  .pick({
    id: true,
    machineServiceId: true,
    privateFileId: true,
    gcsIdentifier: true,
    url: true,
    fileName: true,
    mimeType: true,
    status: true,
  })
  .partial()
  .required({ id: true })

export type MachineServiceDocumentType = z.infer<typeof machineServiceDocumentObject>

export const propertyMap = {
  id: sql`machine_service_document.id`,
  machineServiceId: sql`machine_service_document.machine_service_id`,
  privateFileId: sql`machine_service_document.private_file_id`,
  gcsIdentifier: sql`machine_service_document.gcs_identifier`,
  url: sql`machine_service_document.url`,
  fileName: sql`machine_service_document.file_name`,
  mimeType: sql`machine_service_document.mime_type`,
  status: sql`machine_service_document.status`,
  clientId: sql`machine_service_document.client_id`,
  insertUserId: sql`machine_service_document.insert_user_id`,
  editUserId: sql`machine_service_document.edit_user_id`,
  createdAt: sql`machine_service_document.created_at`,
  updatedAt: sql`machine_service_document.updated_at`,
  deletedAt: sql`machine_service_document.deleted_at`,
}

export default machineServiceDocumentObject
